// Arena football competitions (provider-agnostic config).
export const LEAGUES = [
  { name: 'Premier League', code: 'PL', country: 'England', color: '#3b82f6', currentSeasonCode: 'PL2026' },
  { name: 'Primera Division', code: 'PD', country: 'Spain', color: '#ef4444', currentSeasonCode: 'PD2026' },
  { name: 'Bundesliga', code: 'BL1', country: 'Germany', color: '#d97706', currentSeasonCode: 'BL12026' },
  { name: 'Serie A', code: 'SA', country: 'Italy', color: '#059669', currentSeasonCode: 'SA2026' },
  { name: 'Eliteserien', code: 'EL', country: 'Norway', color: '#0ea5e9', currentSeasonCode: 'EL2026' }
];

export const SUPPORTED_LEAGUE_CODES = LEAGUES.map((l) => l.code);
export const SUPPORTED_LEAGUE_CODES_SET = new Set(SUPPORTED_LEAGUE_CODES);

/**
 * Resolve a supported league code from a value like "PL2025" or "BL1202518".
 */
export function resolveSupportedLeagueCode(value) {
  if (!value) return null;
  const normalized = String(value).toUpperCase();
  const match = SUPPORTED_LEAGUE_CODES.slice()
    .sort((a, b) => b.length - a.length)
    .find((code) => normalized.startsWith(code));
  return match || null;
}

export function isWcLeagueCode(leagueCode) {
  return leagueCode === 'WC';
}

export function isWcSeasonCode(seasonCode) {
  return seasonCode === 'WC2026' || String(seasonCode || '').startsWith('WC');
}

export function isKnockoutGameStage(stage) {
  return stage != null && stage !== '' && stage !== 'GROUP_STAGE';
}
